<template>
  <div class="main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">结算周期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择时间"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>

      <div class="input-item" v-show="userInfo.userType != 3">
        <span class="label">结算单名称</span>
        <Input v-model="searchParams.reportName" clearable placeholder="请输入" />
      </div>

      <div class="input-item" v-show="userInfo.userType != 3">
        <span class="label">发布状态</span>
        <Select v-model="searchParams.releaseStatus" transfer placeholder="请选择" clearable>
          <Option value="1">已发布</Option>
          <Option value="0">未发布</Option>
        </Select>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>
    <Button type="primary" class="btn" @click="addNewReport" v-show="userInfo.userType != 3">新建结算单</Button>
    <Button type="warning" v-if="$units.isOkBao() || $units.isOkTX()" @click="importPlusDeduction">导入</Button>
    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="reportName">
          <span class="table-btn" @click="toDetailPage(row)">{{ row.reportName }}</span>
        </template>

        <template slot-scope="{ row }" slot="releaseStatus">
          <div class="settlement-status">
            <span v-if="row.releaseStatus == '0'" class="tag-settled">未发布</span>
            <span v-else class="tag-be">已发布</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="toDetailPage(row)">详情</span>
          <span class="table-btn" @click="toReleaseStatus(row)" v-show="userInfo.userType != 3">{{ row.releaseStatus == 1 ? '撤销发布' : '发布' }}</span>
          <span class="table-btn" @click="del(row)" v-if="row.releaseStatus == '0' && userInfo.userType != 3">删除</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>
    <!-- 导入 -->
    <policy-import-modal ref="importModal" @success="searchAjax()"></policy-import-modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import { config } from './index.config.js';
import selectTree from '@/components/system/selectTree3';
import policyImportModal from './components/policyImportModal';
import filter from '@/api/filter';

export default {
  mixins: [pageTool, common, config],
  components: {
    selectTree,
    policyImportModal
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      searchParams: {},
      columns: [

        {
          title: '结算单名称',
          align: 'center',
          key: 'reportName',
          minWidth: 250,
          slot: 'reportName'
        },
        {
          title: '发布状态',
          align: 'center',
          minWidth: 120,
          slot: 'releaseStatus'
        },
        {
          title: '机构数',
          align: 'center',
          key: 'orgNum',
          minWidth: 100
        },
        {
          title: '总人数',
          align: 'center',
          key: 'userNum',
          minWidth: 100
        },
        {
          title: '总单量',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 120
        },
        {
          title: '基本法收益',
          align: 'center',
          key: 'methodIncome',
          minWidth: 120
        },
        {
          title: '基本法外基础费用',
          align: 'center',
          key: 'baseIncome',
          minWidth: 150
        },
        {
          title: '无门槛限时加费',
          align: 'center',
          key: 'platformActivityIncome',
          minWidth: 135
        },
        {
          title: '团队长管理费',
          align: 'center',
          key: 'baseLeaderIncome',
          minWidth: 170
        },
        {
          title: '其他活动收益',
          align: 'center',
          key: 'activityIncome',
          minWidth: 130
        },
        {
          title: '加扣款',
          align: 'center',
          key: 'deduction',
          minWidth: 130
        },
        {
          title: '税前合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 130
        },
        {
          title: '个税',
          align: 'center',
          key: 'tax',
          minWidth: 130
        },
        {
          title: '税后合计',
          align: 'center',
          key: 'costAmount',
          minWidth: 130
        },
        {
          title: '操作',
          slot: 'action',
          width: 190,
          align: 'center',
          fixed: 'right'
        }
      ],
      tableData: []
    };
  },
  activated() {
    this.getList();
  },
  methods: {
    importPlusDeduction() {

      this.$refs.importModal.open({
        dicKey: 'user_salary_policy_export', //下载模板字典
        uploadUrl: '/buz/userSalaryDetails/exportPolicyDetail', //上传接口
        reportId: this.reportId,
        name: '导入保单'
      });
    },
    resetSearch() {
      this.searchParams = {};
      this.searchParams.date = [];
      this.searchAjax();
    },
    searchAjax() {
      this.pageNum = 1;
      this.getColumns();
      this.getList();
    },
    getList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchParams));
      if (data.date && data.date.length > 0) {
        data.settlementDateStart = data.date[0];
        data.settlementDateEnd = data.date[1];
      }
      delete data.date;
      this.$http({
        url: '/buz/userSalaryReport/read/page',
        type: 'POST',
        data: {
          ...data,
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          res.data.map(item => {
            item.costAmount = (Number(item.totalIncome) - Number(item.tax)).toFixed(2);
          });
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    toDetailPage(row) {
      if (row.step == '1') {
        this.openPageTabTags('/financialManage/salesmanPaySettlement/editReport', {
          reportId: row.id,
          isAdd: 0,
          step: '1',
          reportName: row.reportName
        });
      } else {
        this.openPageTabTags('/financialManage/salesmanPaySettlement/editReport', {
          reportId: row.id,
          step: row.step,
          reportName: row.reportName,
          settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD') //结算日期
        });
      }
    },
    toReleaseStatus(row) {
      this.$notice.inquiry(`您确定要${row.releaseStatus == 1 ? '撤销发布' : '发布'}吗?`).then(() => {
        this.$http({
          url: row.releaseStatus == 1 ? '/buz/userSalaryReport/revoke' : '/buz/userSalaryReport/release',
          type: 'POST',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success(`${row.releaseStatus == 1 ? '撤销' : '发布'}成功`);
          this.getList();
        });
      });
    },
    del(row) {
      this.$notice.inquiry(`您确定要删除吗?`).then(() => {
        this.$http({
          url: '/buz/userSalaryReport/del',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success(`删除成功`);
          this.getList();
        });
      });
    },
    addNewReport() {
      if (!this.$units.pointAction('offline_81_2_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.openPageTabTags('/financialManage/salesmanPaySettlement/newReport', { isAdd: 1, step: '1', reportName: '新建结算单', time: Date.now() });
    }
  }
};
</script>

<style lang="scss" scoped>
.tableBox {
  margin-top: 15px;
  .settlement-status {
    display: flex;
    .tag-settled {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 2px;
      font-size: 13px;
      color: #e3461f;
      border: 1px solid #ffc1b2;
      background: #fff5f2;
    }
    .tag-be {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 4px;
      font-size: 13px;
      color: #35bf3f;
      border: 1px solid #abeaae;
      background: #f6fcf4;
    }
  }
}
</style>
